// import { Link } from "react-router-dom"
// import { DASHBOARD_LOAN_DETAILS } from "routes"
// import CommaNumber from "comma-number"
// import { StatusDiv } from "components/Dashboard/Home/RecentApplications/style"
// import { ByshelbP } from "globalStyles"

import { DateTime } from "luxon";
import { Link } from "react-router-dom";
import { DASHBOARD_LOAN_DETAILS } from "routes";

export const DISCOLUMNS = [
	{
		title: "First Name",
		fixed:"left",
		width:250,
		render: (originalRow) => <p>{originalRow?.applicant?.first_name + " " +  originalRow?.applicant?.surname}</p>
	},
	{
		title: "NIN",
		width:250,
		render: (originalRow) => <p>{originalRow?.applicant?.nin || "N/A"}</p>
	},
	{
		title: "LGA",
		width:250,
		render: (originalRow) => <p>{originalRow?.applicant?.lga}</p>
	},
	{
		title: "Institution",
		width:250,
		render: (originalRow) => <div style={{ maxWidth: "250px" }}>{originalRow?.institution?.name}</div>
	},
	{
		title: "Amount",
		width:250,
		render: (originalRow) => <p>₦{(originalRow?.amount).toLocaleString()}</p>
	},
	{
		title: "Loan Type",
		dataIndex: "loan_type",
		width:250,

	},
	{
		title: "Disbursed Date",
		width:250,
		render: (originalRow) => <p>{DateTime.fromJSDate(new Date(originalRow?.disburse_date)).toFormat("DD")}</p>
	},
	{
		title: "",
		width:150,
		fixed:"right",
		render: (originalRow) => <Link to={`${DASHBOARD_LOAN_DETAILS}/${originalRow.id}`}><button className="px-6 py-1 justify-center font-semibold rounded-full border border-primary-300 bg-secondary-50 text-primary-700">View</button></Link>
	},
]
